import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/pages/Home.vue';
import About from '../components/pages/About.vue';
import School from '../components/pages/School.vue';
import Events from '../components/pages/Events.vue';
import Contact from '../components/pages/Contact.vue';
import Legal from '../components/pages/Legal.vue';
import Privacy from '../components/pages/Privacy.vue';
import Cookies from '../components/pages/Cookies.vue';
import News from '../components/pages/News.vue';
import Login from '../components/pages/Login.vue';
import Admin from '../components/pages/Admin.vue';
import { requireAdmin } from './guards';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/school',
      name: 'School',
      component: School,
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal,
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
    },
    {
      path: '/cookies',
      name: 'Cookies',
      component: Cookies,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: requireAdmin,
    },
  ]
});

export default router;
